import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-too-many-rows',
  templateUrl: './too-many-rows.component.html',
  styleUrls: ['./too-many-rows.component.scss']
})
export class TooManyRowsComponent {
  @Output() onCancel = new EventEmitter<void>();
}
